import {Loader, useReachGoalCallback} from '@logistics-frontend/blocks'
import React, {useEffect} from 'react'

import {useSharedRoteInfoPolling, useSharedRoute} from '../../hooks'
import {RouterParams} from '../../types'
import {MarginProvider} from '../margin-provider'
import {ActiveScreen, CompleteScreen} from '../screens'

const SharedRoute: React.FC<RouterParams> = ({sharingKey}) => {
  const [{payload, error}] = useSharedRoute()
  const reachGoal = useReachGoalCallback()
  const info = payload?.body

  useSharedRoteInfoPolling(sharingKey)

  useEffect(() => {
    reachGoal('OpenSharedRoute', {sharingKey})
  }, [reachGoal, sharingKey])

  if (Boolean(error)) {
    return <CompleteScreen />
  }

  if (info) {
    return (
      <MarginProvider>
        <ActiveScreen info={info} />
      </MarginProvider>
    )
  }

  return <Loader />
}

export default SharedRoute
